(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart-template"]) return;
  try {
    
  window.__loadCartRewards = function() {
    var container = document.getElementById('cart-rewards-container');
    if (!container || !container.dataset.customerEmail) return;

    var loyaltyUrl = window.theme ? (window.theme.loyaltyUrl || '') : '';
    var loyaltyRewardId = window.theme ? (window.theme.loyaltyRewardId || '') : '';
    var localeRootUrl = window.theme ? (window.theme.localeRootUrl || '') : '';
    var email = container.dataset.customerEmail;

    var loadingEl = document.getElementById('cart-rewards-loading');
    var contentEl = document.getElementById('cart-rewards-content');
    if (!contentEl) return;

    if (loadingEl) loadingEl.style.display = '';
    contentEl.style.display = 'none';

    Promise.all([
      fetch(loyaltyUrl + '/apps/dotapparel21/api-rewardsAccount', {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email: email })
      }).then(function(r) { return r.json(); }),
      fetch(localeRootUrl + '/cart.json').then(function(r) { return r.json(); })
    ])
    .then(function(results) {
      var json = results[0];
      var cart = results[1];
      loadingEl = document.getElementById('cart-rewards-loading');
      contentEl = document.getElementById('cart-rewards-content');

      if (!json || !json.data) {
        if (loadingEl) loadingEl.style.display = 'none';
        return;
      }
      var loyalty = json.data;

      var rewards = (loyalty.rewards || []).filter(function(r) {
        return Number(r.available) > 0 && new Date(r.expires_at) > new Date();
      });

      var fmt = function(cents) { return '$' + (cents / 100).toFixed(2); };
      var fmtDate = function(d) { if (!d) return ''; var dt = new Date(d); if (isNaN(dt.getTime())) return d; var p = function(n) { return n < 10 ? '0' + n : n; }; return p(dt.getDate()) + '/' + p(dt.getMonth() + 1) + '/' + dt.getFullYear(); };

      var html = '<div class="w-full"><div class="mb-4">';
      html += '<h3 class="font-heading text-2xl mb-1/5">Your Rewards</h3>';
      html += '<p class="mb-1 text-20">Reward balance: <span class="font-bold">' + fmt(Number(loyalty.available_rewards) * 100) + '</span></p>';

      rewards.forEach(function(reward) {
        var inCart = cart && cart.items && cart.items.some(function(item) { return item.properties && item.properties._reward_id === reward.id; });
        html += '<div class="RewardItem" style="margin-top: 20px;">';
        html += '<h4 style="margin-bottom: 5px;">' + reward.description + '</h4>';
        html += '<div style="margin-bottom: 5px;">Offer expires <strong>' + fmtDate(reward.expires_at) + '</strong></div>';
        html += '<div style="margin-bottom: 5px;">Value <strong>' + fmt(Number(reward.available) * 100) + '</strong></div>';
        html += '<button class="ProductForm__AddToCart button primary text-base font-semibold uppercase tracking-1/2 large w-full px-2" '
          + 'data-cart-redeem-reward="' + reward.id + '" data-reward-amount="' + reward.available + '" data-reward-expiry="' + reward.expires_at + '"'
          + ' style="min-width: max-content;' + (inCart ? ' opacity: 0.5; pointer-events: none;' : '') + '">'
          + (inCart ? 'REWARD IN CART' : 'REDEEM REWARD') + '</button>';
        html += '</div>';
      });

      if (loyalty.gifts && loyalty.gifts.length) {
        html += '<div class="mb-1">';
        loyalty.gifts.forEach(function(gift) {
          var giftInCart = cart && cart.items && cart.items.some(function(item) { return item.properties && item.properties._gift_id === gift.gift_id; });
          html += '<div style="margin-top: 20px;">';
          html += '<h4 style="margin-bottom: 5px;">' + gift.description + '</h4>';
          if (gift.options && gift.options.length) {
            gift.options.forEach(function(opt) {
              html += '<button class="ProductForm__AddToCart button primary text-base font-semibold uppercase tracking-1/2 large w-full px-2 mt-1" '
                + 'data-cart-redeem-gift="' + opt.shopify_id + '" data-gift-id="' + gift.gift_id + '" data-gift-expiry="' + gift.expires_at + '"'
                + ' style="min-width: max-content;' + (giftInCart ? ' opacity: 0.5; pointer-events: none;' : '') + '">'
                + (giftInCart ? 'GIFT IN CART' : 'REDEEM GIFT') + '</button>';
            });
          }
          html += '</div>';
        });
        html += '</div>';
      }

      html += '</div></div>';
      if (contentEl) {
        contentEl.innerHTML = html;
        contentEl.style.display = '';
      }
      if (loadingEl) loadingEl.style.display = 'none';

      (contentEl || document).querySelectorAll('[data-cart-redeem-reward]').forEach(function(btn) {
        btn.addEventListener('click', function() {
          var rewardAmount = Number(this.dataset.rewardAmount) * 100;
          var value = cart.total_price > rewardAmount ? rewardAmount : cart.total_price;
          fetch(localeRootUrl + '/cart/add.js', {
            method: 'POST', headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ items: [{ quantity: 1, id: loyaltyRewardId, properties: { _key: Date.now(), _reward_amount: value, _reward_id: this.dataset.cartRedeemReward, _expiry_date: this.dataset.rewardExpiry } }] })
          }).then(function() { window.location.reload(); });
        });
      });

      (contentEl || document).querySelectorAll('[data-cart-redeem-gift]').forEach(function(btn) {
        btn.addEventListener('click', function() {
          fetch(localeRootUrl + '/cart/add.js', {
            method: 'POST', headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ items: [{ quantity: 1, id: Number(this.dataset.cartRedeemGift), properties: { _key: Date.now(), _gift_id: this.dataset.giftId, _expiry_date: this.dataset.giftExpiry } }] })
          }).then(function() { window.location.reload(); });
        });
      });
    })
    .catch(function(e) {
      console.warn('Cart rewards error:', e);
      var loadingEl = document.getElementById('cart-rewards-loading');
      if (loadingEl) loadingEl.style.display = 'none';
    });
  };

  // Initial load
  window.__loadCartRewards();

  // Re-run after section re-render (cart AJAX updates)
  var cartSection = document.querySelector('section[data-section-type="cart"]');
  if (cartSection) {
    new MutationObserver(function() {
      window.__loadCartRewards();
    }).observe(cartSection, { childList: true });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-template"]) return;
  try {
    
  (function() {
    var section = document.querySelector('[data-section-type="collection"]');
    if (!section) return;

    var sectionEl = section.closest('.shopify-section');
    if (!sectionEl) return;
    var sectionId = sectionEl.id.replace('shopify-section-', '');

    // Intercept filter links, sort links, pagination links, and clear filter links
    document.addEventListener('click', function(e) {
      var filterLink = e.target.closest('[data-collection-filter-link], [data-collection-clear-filters], .Pagination a');
      if (filterLink && filterLink.href) {
        e.preventDefault();
        fetchAndReplace(filterLink.href);
        return;
      }

      var sortLink = e.target.closest('[data-sort-value]');
      if (sortLink) {
        e.preventDefault();
        var value = sortLink.getAttribute('data-sort-value');
        var url = new URL(window.location.href);
        url.searchParams.set('sort_by', value);
        fetchAndReplace(url.toString());
        return;
      }
    });

    // Intercept price filter form submit
    document.addEventListener('submit', function(e) {
      var priceForm = e.target.closest('[data-collection-price-form]');
      if (priceForm) {
        e.preventDefault();
        var url = new URL(window.location.href);
        var formData = new FormData(priceForm);
        // Clear existing price filters
        Array.from(url.searchParams.keys()).forEach(function(key) {
          if (key.startsWith('filter.v.price')) url.searchParams.delete(key);
        });
        formData.forEach(function(value, key) {
          if (value) url.searchParams.set(key, Math.round(parseFloat(value) * 100));
        });
        fetchAndReplace(url.toString());
      }
    });

    function withAvailabilityFilter(url) {
      try {
        var u = new URL(url, window.location.origin);
        u.searchParams.set('filter.v.availability', '1');
        return u.toString();
      } catch (e) {
        return url;
      }
    }

    function fetchAndReplace(url) {
      url = withAvailabilityFilter(url);
      // Capture filter drawer state BEFORE the network round-trip
      var existingFilterDrawer = document.querySelector('#collection-filter-drawer');
      var filterDrawerWasOpen = existingFilterDrawer && existingFilterDrawer.getAttribute('aria-hidden') === 'false';

      // While the drawer is open we do an in-place swap (no destroy/recreate),
      // so we need to preserve the drawer's internal scroll position and which
      // Collapsible filter sections the user has expanded.
      var drawerScrollTop = 0;
      var openCollapsibleIndexes = [];
      if (filterDrawerWasOpen) {
        var existingScrollEl = existingFilterDrawer.querySelector('[data-scrollable]');
        if (existingScrollEl) drawerScrollTop = existingScrollEl.scrollTop;
        Array.from(existingFilterDrawer.querySelectorAll('.Collapsible')).forEach(function(c, i) {
          if (c.classList.contains('is-open')) openCollapsibleIndexes.push(i);
        });
      }

      // Show loading state
      var productGrid = section.querySelector('.ProductList');
      if (productGrid) productGrid.style.opacity = '0.5';

      var separator = url.includes('?') ? '&' : '?';
      var fetchUrl = url + separator + 'sections=' + sectionId;

      fetch(fetchUrl, { credentials: 'same-origin' })
        .then(function(r) { return r.json(); })
        .then(function(data) {
          var html = data[sectionId];
          if (!html) {
            window.location.href = url;
            return;
          }

          window.history.pushState({}, '', url);

          if (filterDrawerWasOpen) {
            // Surgical update — keep the drawer wrapper (and its open state) in place
            // and swap only the parts that change. This avoids the slide-out/slide-in
            // flash that happens when the whole section is innerHTML-replaced.
            var temp = document.createElement('div');
            temp.innerHTML = html;

            var newFilters = temp.querySelector('#collection-filter-drawer [data-collection-filters]');
            var oldFilters = existingFilterDrawer.querySelector('[data-collection-filters]');
            if (newFilters && oldFilters) oldFilters.innerHTML = newFilters.innerHTML;

            var newProducts = temp.querySelector('[data-collection-products]');
            var oldProducts = document.querySelector('[data-collection-products]');
            if (newProducts && oldProducts) oldProducts.innerHTML = newProducts.innerHTML;

            var newFilterBtn = temp.querySelector('.CollectionToolbar__Item--filter');
            var oldFilterBtn = document.querySelector('.CollectionToolbar__Item--filter');
            if (newFilterBtn && oldFilterBtn) oldFilterBtn.innerHTML = newFilterBtn.innerHTML;

            // Restore drawer scroll + previously-open Collapsibles
            var newScrollEl = existingFilterDrawer.querySelector('[data-scrollable]');
            if (newScrollEl) newScrollEl.scrollTop = drawerScrollTop;
            var newCollapsibles = existingFilterDrawer.querySelectorAll('.Collapsible');
            openCollapsibleIndexes.forEach(function(idx) {
              var c = newCollapsibles[idx];
              if (!c || c.classList.contains('is-open')) return;
              c.classList.add('is-open');
              var inner = c.querySelector('.Collapsible__Inner');
              if (inner) {
                inner.style.visibility = 'visible';
                inner.style.height = 'auto';
                inner.style.overflow = 'visible';
              }
              var btn = c.querySelector('[data-action="toggle-collapsible"]');
              if (btn) btn.setAttribute('aria-expanded', 'true');
            });
          } else {
            // Drawer closed — full-section replace + scroll to top, original behaviour
            sectionEl.innerHTML = html;
            if (window.initCollectionDescription) window.initCollectionDescription(sectionEl);
            document.body.classList.remove('has-openDrawer', 'has-openModal');
            document.documentElement.style.overflow = '';
            var overlay = document.querySelector('.PageOverlay');
            if (overlay) overlay.classList.remove('is-visible');
            document.querySelectorAll('.Drawer:not(.hidden)').forEach(function(d) {
              d.classList.add('hidden');
              d.setAttribute('aria-hidden', 'true');
            });
            window.scrollTo({ top: 0, behavior: 'smooth' });
          }
        })
        .catch(function() {
          // Fallback to full page load
          window.location.href = url;
        });
    }

    // Handle browser back/forward
    window.addEventListener('popstate', function() {
      fetchAndReplace(window.location.href);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dynamic-section-stores-locator"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var mapEl = document.getElementById('store-locator-map');
    var dataEl = document.getElementById('store-locator-data');
    if (!mapEl || !dataEl) return;

    var stores = [];
    try { stores = JSON.parse(dataEl.textContent); } catch(e) { return; }
    if (!stores.length) return;

    var sectionEl = mapEl.closest('[data-maps-key]');
    var apiKey = sectionEl ? sectionEl.dataset.mapsKey : '';
    var searchRadius = sectionEl ? parseInt(sectionEl.dataset.searchRadius, 10) || 50 : 50;

    if (!apiKey) {
      mapEl.style.display = 'none';
      return;
    }

    var map, markers = [], infoWindow, geocoder;

    function loadGoogleMaps() {
      var script = document.createElement('script');
      script.src = 'https://maps.googleapis.com/maps/api/js?key=' + apiKey + '&libraries=places&callback=initStoreLocatorMap';
      script.async = true;
      script.defer = true;
      document.head.appendChild(script);
    }

    window.initStoreLocatorMap = function() {
      var bounds = new google.maps.LatLngBounds();
      map = new google.maps.Map(mapEl, {
        zoom: 10,
        mapTypeControl: false,
        streetViewControl: false,
        fullscreenControl: true,
        styles: [
          { elementType: 'geometry', stylers: [{ color: '#f5f5f5' }] },
          { elementType: 'labels.icon', stylers: [{ visibility: 'off' }] },
          { elementType: 'labels.text.fill', stylers: [{ color: '#616161' }] },
          { elementType: 'labels.text.stroke', stylers: [{ color: '#f5f5f5' }] },
          { featureType: 'administrative.land_parcel', stylers: [{ visibility: 'off' }] },
          { featureType: 'administrative.land_parcel', elementType: 'labels.text.fill', stylers: [{ color: '#bdbdbd' }] },
          { featureType: 'poi', stylers: [{ visibility: 'off' }] },
          { featureType: 'road', elementType: 'geometry', stylers: [{ color: '#ffffff' }] },
          { featureType: 'road.arterial', elementType: 'labels.text.fill', stylers: [{ color: '#757575' }] },
          { featureType: 'road.highway', elementType: 'geometry', stylers: [{ color: '#dadada' }] },
          { featureType: 'road.local', elementType: 'labels.text.fill', stylers: [{ color: '#9e9e9e' }] },
          { featureType: 'transit', stylers: [{ visibility: 'off' }] },
          { featureType: 'water', elementType: 'geometry', stylers: [{ color: '#c9c9c9' }] },
          { featureType: 'water', elementType: 'labels.text.fill', stylers: [{ color: '#9e9e9e' }] }
        ]
      });
      infoWindow = new google.maps.InfoWindow();
      geocoder = new google.maps.Geocoder();

      var markerIcon = {
        url: 'data:image/svg+xml;charset=UTF-8,' + encodeURIComponent('<svg xmlns="http://www.w3.org/2000/svg" width="30" height="40" viewBox="0 0 30 40"><path d="M15 0C6.7 0 0 6.7 0 15c0 11.25 15 25 15 25s15-13.75 15-25C30 6.7 23.3 0 15 0z" fill="#000"/><text x="15" y="20" text-anchor="middle" fill="#fff" font-size="11" font-family="serif">C</text></svg>'),
        scaledSize: new google.maps.Size(30, 40),
        anchor: new google.maps.Point(15, 40)
      };

      stores.forEach(function(store, i) {
        if (!store.lat || !store.lng) return;
        var pos = { lat: parseFloat(store.lat), lng: parseFloat(store.lng) };
        bounds.extend(pos);

        var marker = new google.maps.Marker({
          position: pos,
          map: map,
          title: store.name,
          icon: markerIcon
        });
        markers.push({ marker: marker, index: i });

        marker.addListener('click', function() {
          var directionsUrl = 'https://www.google.com/maps/dir/?api=1&destination=' + store.lat + ',' + store.lng;
          var content = '<div style="padding:0 16px 16px;min-width:280px;font-family:inherit;line-height:1.5;font-size:12px;">';
          content += '<h3 style="font-size:14px;font-weight:700;margin:0 0 8px;font-family:inherit;line-height:1.3;">' + store.name + '</h3>';
          if (store.address) {
            var addr = store.address.split('||').join('<br>');
            content += '<div style="font-size:12px;font-weight:300;margin-bottom:8px;text-transform:uppercase;line-height:1.5;">' + addr + '</div>';
          }
          content += '<a href="' + directionsUrl + '" target="_blank" style="display:block;font-size:12px;color:#000;text-decoration:underline;margin-bottom:8px;outline:none;">DIRECTIONS</a>';
          if (store.phone) content += '<div style="font-size:12px;font-weight:300;margin-bottom:8px;">PH: ' + store.phone + '</div>';
          if (store.url) content += '<a href="' + store.url + '" style="display:block;font-size:12px;color:#000;text-decoration:underline;text-transform:uppercase;outline:none;margin-bottom:8px;">STORE DETAILS</a>';
          if (store.hours && store.hours.children) {
            var dayNames = ['Sunday','Monday','Tuesday','Wednesday','Thursday','Friday','Saturday'];
            var todayName = dayNames[new Date().getDay()];
            var todayLine = null;
            store.hours.children.forEach(function(p) {
              if (p.children) p.children.forEach(function(t) {
                if (t.value && t.value.toLowerCase().indexOf(todayName.toLowerCase()) === 0) {
                  todayLine = t.value;
                }
              });
            });
            if (todayLine) {
              var parts = todayLine.split(' - ');
              var timeRange = parts.slice(1).join(' - ');
              var now = new Date();
              var h = now.getHours();
              var isOpen = (h >= 9 && h < 17);
              if (todayLine.toLowerCase().includes('closed')) isOpen = false;
              var match = todayLine.match(/(\d+)[.:]\d+\s*(am|pm)/gi);
              if (match && match.length >= 2) {
                var openStr = match[0], closeStr = match[1];
                var oH = parseInt(openStr); if (/pm/i.test(openStr) && oH !== 12) oH += 12; if (/am/i.test(openStr) && oH === 12) oH = 0;
                var cH = parseInt(closeStr); if (/pm/i.test(closeStr) && cH !== 12) cH += 12; if (/am/i.test(closeStr) && cH === 12) cH = 0;
                isOpen = (h >= oH && h < cH);
              }
              var statusColor = isOpen ? '#2d8a39' : '#c0392b';
              var statusText = isOpen ? 'Open' : 'Closed';
              content += '<div style="display:flex;justify-content:space-between;align-items:center;font-size:12px;font-weight:300;gap:20px;">';
              content += '<span>Today ' + timeRange + '</span>';
              content += '<span style="color:' + statusColor + ';font-weight:400;">' + statusText + '</span>';
              content += '</div>';
            }
          }
          content += '</div>';
          infoWindow.setContent(content);
          infoWindow.open(map, marker);
        });
      });

      map.fitBounds(bounds);
      if (stores.length === 1) map.setZoom(14);

      var cards = document.querySelectorAll('.StoreLocator-card');
      cards.forEach(function(card) {
        card.addEventListener('click', function(e) {
          if (e.target.closest('a')) return;
          var lat = parseFloat(card.dataset.storeLat);
          var lng = parseFloat(card.dataset.storeLng);
          if (lat && lng) {
            map.panTo({ lat: lat, lng: lng });
            map.setZoom(14);
            var idx = parseInt(card.dataset.storeIndex, 10);
            var found = markers.find(function(m) { return m.index === idx; });
            if (found) {
              google.maps.event.trigger(found.marker, 'click');
            }
          }
          cards.forEach(function(c) { c.classList.remove('is-active'); });
          card.classList.add('is-active');
        });
      });

      var searchInput = document.getElementById('store-locator-search-input');
      var searchBtn = document.getElementById('store-locator-search-btn');
      var geolocateBtn = document.getElementById('store-locator-geolocate');

      var autocomplete = new google.maps.places.Autocomplete(searchInput, {
        types: ['(regions)'],
        componentRestrictions: { country: 'au' }
      });
      autocomplete.addListener('place_changed', function() {
        var place = autocomplete.getPlace();
        if (place.geometry) {
          filterByDistance(place.geometry.location.lat(), place.geometry.location.lng());
        }
      });

      function searchLocation(query) {
        if (!geocoder || !query) return;
        geocoder.geocode({ address: query + ', Australia' }, function(results, status) {
          if (status === 'OK' && results[0]) {
            var loc = results[0].geometry.location;
            filterByDistance(loc.lat(), loc.lng());
          }
        });
      }

      function filterByDistance(lat, lng) {
        var origin = new google.maps.LatLng(lat, lng);
        var visibleBounds = new google.maps.LatLngBounds();
        var hasVisible = false;
        var cardDistances = [];

        cards.forEach(function(card, i) {
          card.style.display = '';
          card.classList.remove('is-active');
        });
        markers.forEach(function(m) { m.marker.setMap(map); });

        stores.forEach(function(store, i) {
          if (!store.lat || !store.lng) return;
          var storeLoc = new google.maps.LatLng(parseFloat(store.lat), parseFloat(store.lng));
          var dist = getDistanceKm(lat, lng, parseFloat(store.lat), parseFloat(store.lng));

          if (dist > searchRadius) {
            if (cards[i]) cards[i].style.display = 'none';
            var found = markers.find(function(m) { return m.index === i; });
            if (found) found.marker.setMap(null);
          } else {
            visibleBounds.extend(storeLoc);
            hasVisible = true;
          }

          if (cards[i]) {
            cards[i].dataset.dist = dist;
            var distEl = cards[i].querySelector('[data-distance]');
            if (distEl) {
              distEl.textContent = Math.round(dist) + 'km';
            }
          }
          cardDistances.push({ card: cards[i], dist: dist });
        });

        var list = document.getElementById('store-locator-list');
        cardDistances
          .filter(function(cd) { return cd.card && cd.card.style.display !== 'none'; })
          .sort(function(a, b) { return a.dist - b.dist; })
          .forEach(function(cd) { list.appendChild(cd.card); });

        if (hasVisible) {
          map.fitBounds(visibleBounds);
        } else {
          map.panTo({ lat: lat, lng: lng });
          map.setZoom(10);
        }
      }

      function getDistanceKm(lat1, lng1, lat2, lng2) {
        var R = 6371;
        var dLat = (lat2 - lat1) * Math.PI / 180;
        var dLng = (lng2 - lng1) * Math.PI / 180;
        var a = Math.sin(dLat/2) * Math.sin(dLat/2) +
          Math.cos(lat1 * Math.PI / 180) * Math.cos(lat2 * Math.PI / 180) *
          Math.sin(dLng/2) * Math.sin(dLng/2);
        return R * 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1-a));
      }

      if (searchBtn) {
        searchBtn.addEventListener('click', function() {
          searchLocation(searchInput.value.trim());
        });
      }
      if (searchInput) {
        searchInput.addEventListener('keydown', function(e) {
          if (e.key === 'Enter') {
            e.preventDefault();
            searchLocation(searchInput.value.trim());
          }
        });
      }

      if (geolocateBtn) {
        geolocateBtn.addEventListener('click', function() {
          if (!navigator.geolocation) return;
          geolocateBtn.setAttribute('disabled', '');
          navigator.geolocation.getCurrentPosition(
            function(pos) {
              geolocateBtn.removeAttribute('disabled');
              filterByDistance(pos.coords.latitude, pos.coords.longitude);
            },
            function() {
              geolocateBtn.removeAttribute('disabled');
            }
          );
        });
      }
    };

    loadGoogleMaps();

    var carousel = document.getElementById('boutique-carousel');
    var prevBtn = document.getElementById('boutique-prev');
    var nextBtn = document.getElementById('boutique-next');
    if (carousel && prevBtn && nextBtn) {
      function getScrollAmount() {
        var card = carousel.querySelector('.StoreLocator-boutique-card');
        if (!card) return 320;
        var style = getComputedStyle(carousel);
        var gap = parseFloat(style.gap) || parseFloat(style.columnGap) || 0;
        return card.offsetWidth + gap;
      }
      prevBtn.addEventListener('click', function() {
        carousel.scrollBy({ left: -getScrollAmount(), behavior: 'smooth' });
      });
      nextBtn.addEventListener('click', function() {
        carousel.scrollBy({ left: getScrollAmount(), behavior: 'smooth' });
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gift-card-balance"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var form = document.querySelector('.shopify-section--gift-card-balance form');
    if (!form) return;

    var balanceDisplay = document.querySelector('.shopify-section--gift-card-balance .balance-display');
    var errorMessage = document.querySelector('.shopify-section--gift-card-balance .error-message');
    var resetBtn = balanceDisplay ? balanceDisplay.querySelector('.Form__Submit') : null;

    form.addEventListener('submit', function(e) {
      e.preventDefault();
      var number = document.getElementById('gift-card-number').value.trim();
      var pin = document.getElementById('gift-card-pin').value.trim();
      if (!number || !pin) return;

      var submitBtn = form.querySelector('[type="submit"]');
      submitBtn.disabled = true;
      submitBtn.textContent = 'CHECKING...';
      errorMessage.classList.add('hidden');

      fetch('/apps/dotapparel21/api-checkGiftcardBalance', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ number: number, pin: pin })
      })
      .then(function(r) { return r.json(); })
      .then(function(data) {
        submitBtn.disabled = false;
        submitBtn.textContent = 'CHECK BALANCE';

        if (data.status === 'success' && data.data) {
          balanceDisplay.querySelector('#gift-card-number').value = data.data.voucherNumber || '';
          balanceDisplay.querySelector('#gift-card-value').value = '$' + (data.data.originalAmount || '0.00');
          balanceDisplay.querySelector('#gift-card-balance').value = '$' + (data.data.availableAmount || '0.00');
          balanceDisplay.querySelector('#gift-card-expires').value = data.data.expiryDate ? data.data.expiryDate.split('-').reverse().join('/') : '';
          form.classList.add('hidden');
          balanceDisplay.classList.remove('hidden');
        } else {
          errorMessage.textContent = data.errorMessage || 'This voucher has already been redeemed or has expired.';
          errorMessage.classList.remove('hidden');
        }
      })
      .catch(function() {
        submitBtn.disabled = false;
        submitBtn.textContent = 'CHECK BALANCE';
        errorMessage.textContent = 'An error occurred. Please try again.';
        errorMessage.classList.remove('hidden');
      });
    });

    if (resetBtn) {
      resetBtn.addEventListener('click', function(e) {
        e.preventDefault();
        form.reset();
        form.classList.remove('hidden');
        balanceDisplay.classList.add('hidden');
        errorMessage.classList.add('hidden');
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  document.addEventListener('change', function(event) {
    if (!event.target.matches('.CurrencySelector__Select')) return;

    // Reload the current page with the currency param
    const selectedCurrency = event.target.value;
    const url = new URL(window.location.href);    
    url.searchParams.set('currency', selectedCurrency);
    window.location.href = url.href;
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["instagram-feed"] && !Shopify.designMode) return;
  try {
    
  (function() {
    document.querySelectorAll('.instafeed-carousel-wrap').forEach(function(wrap) {
      var track = wrap.querySelector('.instafeed-track');
      if (!track) return;

      var prev = wrap.querySelector('.instafeed-arrow--prev');
      var next = wrap.querySelector('.instafeed-arrow--next');

      function getSlideWidth() {
        var firstChild = track.firstElementChild;
        return firstChild ? firstChild.offsetWidth : 300;
      }

      function updateArrows() {
        if (prev) prev.classList.toggle('is-hidden', track.scrollLeft <= 10);
        if (next) next.classList.toggle('is-hidden', track.scrollLeft + track.clientWidth >= track.scrollWidth - 10);
      }

      if (prev) prev.addEventListener('click', function() {
        track.scrollBy({ left: -getSlideWidth(), behavior: 'smooth' });
      });
      if (next) next.addEventListener('click', function() {
        track.scrollBy({ left: getSlideWidth(), behavior: 'smooth' });
      });

      track.addEventListener('scroll', updateArrows);
      updateArrows();

      var observer = new MutationObserver(function() { updateArrows(); });
      observer.observe(track, { childList: true });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-register"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var form = document.getElementById('RegisterForm');
    if (!form) return;

    var submitBtn = document.getElementById('register-submit');
    var errorsEl = document.getElementById('register-errors');
    var shop = window.Shopify && window.Shopify.shop ? window.Shopify.shop.replace('.myshopify.com', '') : '';

    function formatDate(dateStr) {
      var d = new Date(dateStr);
      var pad = function(n) { return n < 10 ? '0' + n : n; };
      return pad(d.getDate()) + '/' + pad(d.getMonth() + 1) + '/' + d.getFullYear();
    }

    function normalizeBirthday(input) {
      if (!input) return '';
      if (input.indexOf('/') !== -1) return input;
      if (input.indexOf('-') !== -1) {
        var parts = input.split('-');
        if (parts.length === 3) return parts[2] + '/' + parts[1] + '/' + parts[0];
      }
      return formatDate(input);
    }

    function showErrors(messages) {
      if (!Array.isArray(messages)) messages = [messages];
      errorsEl.innerHTML = '<div class="Form__Alert Alert Alert--error"><ul class="Alert__ErrorList">' +
        messages.map(function(m) { return '<li class="Alert__ErrorItem">' + m + '</li>'; }).join('') +
        '</ul></div>';
    }

    function clearErrors() {
      errorsEl.innerHTML = '';
    }

    form.addEventListener('submit', function(e) {
      e.preventDefault();
      clearErrors();

      var firstName = form.querySelector('[name="customer[first_name]"]').value.trim();
      var lastName = form.querySelector('[name="customer[last_name]"]').value.trim();
      var email = form.querySelector('[name="customer[email]"]').value.trim();
      var password = form.querySelector('[name="customer[password]"]').value.trim();
      var birthday = normalizeBirthday(form.querySelector('[name="birthday"]').value);
      var marketing = form.querySelector('[name="customer[accepts_marketing]"]').checked;

      var phoneInput = form.querySelector('intl-phone-input');
      var phoneRaw = phoneInput ? phoneInput.querySelector('[data-phone]').value.trim() : '';
      var phoneParsed = phoneInput ? phoneInput.parsedNumber : null;
      var phoneValid = phoneInput ? phoneInput.isValid : true;

      if (!firstName || !lastName || !email || !password) {
        showErrors('Please fill in all required fields.');
        return;
      }

      if (phoneRaw && !phoneValid) {
        showErrors('Please enter a valid phone number.');
        return;
      }

      var tags = [];
      if (birthday) tags.push('DOB: ' + birthday);

      var data = {
        firstName: firstName,
        lastName: lastName,
        email: email,
        password: password,
        acceptsMarketing: marketing,
        phone: phoneParsed || undefined,
        tags: tags
      };

      submitBtn.style.opacity = '0.6';
      submitBtn.disabled = true;

      fetch('https://australia-southeast1-cable-dotapparel21-au.cloudfunctions.net/customerRegister', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          'shop': shop
        },
        body: JSON.stringify(data)
      })
      .then(function(res) {
        return res.json().then(function(json) {
          return { status: res.status, body: json };
        });
      })
      .then(function(result) {
        if (result.status !== 200) {
          var msg = 'There was an error signing up.';
          if (result.body && result.body.body) {
            if (Array.isArray(result.body.body) && typeof result.body.body[0] === 'string') {
              msg = result.body.body[0];
            } else if (typeof result.body.body === 'string') {
              msg = result.body.body;
            }
          }
          showErrors(msg);
          submitBtn.style.opacity = '';
          submitBtn.disabled = false;
          return;
        }

        var hiddenLogin = document.getElementById('hidden-login');
        if (hiddenLogin) {
          hiddenLogin.querySelector('[name="customer[email]"]').value = email;
          hiddenLogin.querySelector('[name="customer[password]"]').value = password;
          hiddenLogin.submit();
        }
      })
      .catch(function() {
        showErrors('There was an error signing up.');
        submitBtn.style.opacity = '';
        submitBtn.disabled = false;
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nosto-placements"] && !Shopify.designMode) return;
  try {
    
  // Tagalys search visibility
  function applyTagalysSearchVisibility(placementItemEl, detail) {
    var noQuery = (detail || {}).noQuery;
    var empty = (detail || {}).empty;
    placementItemEl.classList.toggle('nosto-placements__item--tagalys-hidden', !noQuery && !empty);
  }

  window.addEventListener('tagalys:search-results', function(e) {
    document.querySelectorAll('[data-nosto-tagalys-search-visibility]').forEach(function(el) {
      applyTagalysSearchVisibility(el, e.detail);
    });
  });

  // Carousel management
  (function() {
    function markCarouselReady(shell) {
      shell.classList.add('is-nosto-carousel-ready');
    }

    function hidePlacementWithoutProducts(shell) {
      var item = shell.closest('.nosto-placements__item');
      if (item) item.classList.add('nosto-placements__item--empty');
      markCarouselReady(shell);
    }

    function initCarousel(sliderEl) {
      if (sliderEl._nostoCarouselInitialized) return;
      sliderEl._nostoCarouselInitialized = true;

      var shell = sliderEl.closest('[data-nosto-carousel-shell]');
      if (shell) markCarouselReady(shell);

      var blockId = sliderEl.getAttribute('data-block-id');
      if (!blockId) return;

      var prevBtn = document.querySelector('.nosto-carousel-prev-' + blockId);
      var nextBtn = document.querySelector('.nosto-carousel-next-' + blockId);

      function getSlideWidth() {
        var firstSlide = sliderEl.firstElementChild;
        return firstSlide ? firstSlide.offsetWidth : 300;
      }

      function updateArrows() {
        if (prevBtn) prevBtn.classList.toggle('greyed', sliderEl.scrollLeft <= 10);
        if (nextBtn) nextBtn.classList.toggle('greyed', sliderEl.scrollLeft + sliderEl.clientWidth >= sliderEl.scrollWidth - 10);
      }

      if (prevBtn) {
        prevBtn.addEventListener('click', function() {
          sliderEl.scrollBy({ left: -getSlideWidth(), behavior: 'smooth' });
        });
      }
      if (nextBtn) {
        nextBtn.addEventListener('click', function() {
          sliderEl.scrollBy({ left: getSlideWidth(), behavior: 'smooth' });
        });
      }

      sliderEl.addEventListener('scroll', updateArrows);
      updateArrows();
    }

    function initCarousels() {
      document.querySelectorAll('[data-nosto-products-slider]').forEach(initCarousel);
    }

    document.addEventListener('@nosto/DynamicCard/loaded', initCarousels);

    // Nosto campaign loader. Mirrors <nosto-campaign> but passes skipEvents so the
    // recommendation fetch does not re-record the page's view-product event.
    if (!window.__nostoCampaignLoaderBound) {
      window.__nostoCampaignLoaderBound = true;

      window.nostojs =
        window.nostojs ||
        function (cb) {
          (window.nostojs.q = window.nostojs.q || []).push(cb);
        };

      var BATCH_MS = 50;
      var queue = [];
      var timer = null;

      var escapeAttr = function (value) {
        return String(value == null ? '' : value).replace(/"/g, '&quot;');
      };

      var buildMarkup = function (el, products) {
        var items = products
          .map(function (product) {
            if (!product || !product.handle) return '';
            return (
              '<div class="flex-shrink-0" style="scroll-snap-align: start;">' +
              '<nosto-dynamic-card handle="' + escapeAttr(product.handle) + '" section="nosto-product-card"></nosto-dynamic-card>' +
              '</div>'
            );
          })
          .join('');
        if (!items) return '';
        return (
          '<div class="dynamic-products">' +
          '<div class="ProductList ProductList--carousel flex overflow-x-auto" data-nosto-products-slider' +
          ' data-per-page="' + escapeAttr(el.getAttribute('data-nosto-per-page')) + '"' +
          ' data-block-id="' + escapeAttr(el.getAttribute('data-nosto-block-id')) + '"' +
          ' aria-label="' + escapeAttr(el.getAttribute('data-nosto-label')) + '">' +
          items +
          '</div>' +
          '</div>'
        );
      };

      var render = function (el, campaign) {
        var shell = el.closest('[data-nosto-carousel-shell]');
        var products = campaign && campaign.products;
        var markup = products && products.length ? buildMarkup(el, products) : '';

        // No products: drop the skeleton and hide the placement, rather than
        // leaving the skeleton spinning forever.
        if (!markup) {
          if (shell) hidePlacementWithoutProducts(shell);
          return;
        }

        // Skeleton stays up until the first card actually renders; the existing
        // '@nosto/DynamicCard/loaded' listener calls initCarousels, which marks the
        // shell ready. Don't call it here or the skeleton drops to empty space.
        el.innerHTML = markup;
        window.nostojs(function (api) {
          if (typeof api.attributeProductClicksInCampaign !== 'function') return;
          try {
            api.attributeProductClicksInCampaign(el, campaign);
          } catch (e) {}
        });
      };

      var flush = function () {
        timer = null;
        var batch = queue.slice();
        queue = [];
        if (!batch.length) return;

        window.nostojs(function (api) {
          if (typeof api.createRecommendationRequest !== 'function') return;
          api
            .createRecommendationRequest({ includeTagging: true })
            .disableCampaignInjection()
            .setElements(
              batch.map(function (el) {
                return el.getAttribute('data-nosto-placement');
              })
            )
            .setResponseMode('JSON_ORIGINAL')
            // The whole point: this request is a fetch, not a report. Without it the
            // page's view-product event is transmitted a second time.
            .load({ skipEvents: true })
            .then(function (result) {
              var recommendations = (result && result.recommendations) || {};
              batch.forEach(function (el) {
                render(el, recommendations[el.getAttribute('data-nosto-placement')]);
              });
            })
            .catch(function () {
              batch.forEach(function (el) {
                var shell = el.closest('[data-nosto-carousel-shell]');
                if (shell) hidePlacementWithoutProducts(shell);
              });
            });
        });
      };

      var enqueue = function (el) {
        if (el.__nostoRequested) return;
        el.__nostoRequested = true;
        queue.push(el);
        if (timer === null) timer = setTimeout(flush, BATCH_MS);
      };

      var bind = function (el) {
        if (el.__nostoBound) return;
        el.__nostoBound = true;

        if (el.getAttribute('data-nosto-cart-synced') === 'true') {
          window.nostojs(function (api) {
            if (typeof api.listen !== 'function') return;
            api.listen('cartupdated', function () {
              el.__nostoRequested = false;
              enqueue(el);
            });
          });
        }

        if (el.getAttribute('data-nosto-lazy') === 'true' && typeof IntersectionObserver !== 'undefined') {
          var observer = new IntersectionObserver(function (entries) {
            if (!entries[0].isIntersecting) return;
            observer.disconnect();
            enqueue(el);
          });
          observer.observe(el);
          return;
        }

        enqueue(el);
      };

      var initCampaigns = function () {
        document.querySelectorAll('[data-nosto-placement]').forEach(bind);
      };

      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initCampaigns);
      } else {
        initCampaigns();
      }
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-template"]) return;
  try {
    
  (function() {
    document.querySelectorAll('.product-slideshow').forEach(function(slideshow) {
      var slides = slideshow.querySelectorAll('.Product__SlideItem');
      if (slides.length < 1) return;

      var section = slideshow.closest('[data-section-type="product"]');
      var thumbnails = section ? section.querySelectorAll('.Product__SlideshowNavImage') : [];
      var dotsContainer = section ? section.querySelector('[data-slideshow-dots]') : null;
      var dots = dotsContainer ? dotsContainer.querySelectorAll('.Product__SlideshowDot') : [];
      var prevArrow = section ? section.querySelector('[data-slideshow-prev]') : null;
      var nextArrow = section ? section.querySelector('[data-slideshow-next]') : null;
      var initialIndex = parseInt(slideshow.dataset.initialIndex, 10) || 0;
      var currentIndex = initialIndex;

      var scrollAnim;
      function scrollToSlide(index, behavior) {
        if (!slides[index]) return;
        var target = slides[index].offsetLeft;

        // Native scrollTo({behavior:'smooth'}) is unreliable on a container with
        // scroll-snap-type: mandatory (it no-ops in Chrome), so animate scrollLeft
        // directly. Used by the dots, thumbnails and the mobile arrows.
        if (scrollAnim) { cancelAnimationFrame(scrollAnim); scrollAnim = null; }
        slideshow.style.scrollSnapType = ''; // reset in case a prior animation was interrupted

        if (behavior === 'auto') {
          slideshow.scrollLeft = target;
          return;
        }

        var start = slideshow.scrollLeft;
        var dist = target - start;
        if (Math.abs(dist) < 1) { slideshow.scrollLeft = target; return; }

        // Mandatory snap reverts any non-snap scrollLeft back to the current snap
        // point, which kills a frame-by-frame animation. Disable snap for the
        // duration of the animation, then restore it once landed on the target.
        slideshow.style.scrollSnapType = 'none';

        var duration = 300;
        var startTime = null;
        function step(ts) {
          if (startTime === null) startTime = ts;
          var p = Math.min((ts - startTime) / duration, 1);
          var eased = 1 - Math.pow(1 - p, 3); // easeOutCubic
          slideshow.scrollLeft = start + dist * eased;
          if (p < 1) {
            scrollAnim = requestAnimationFrame(step);
          } else {
            slideshow.scrollLeft = target;
            slideshow.style.scrollSnapType = '';
            scrollAnim = null;
          }
        }
        scrollAnim = requestAnimationFrame(step);
      }

      if (initialIndex > 0) {
        scrollToSlide(initialIndex, 'auto');
      }

      function updateSelection(index) {
        currentIndex = index;

        slides.forEach(function(s) { s.classList.remove('is-selected'); });
        if (slides[currentIndex]) slides[currentIndex].classList.add('is-selected');

        thumbnails.forEach(function(thumb) { thumb.classList.remove('is-selected'); });
        if (slides[currentIndex]) {
          var imageId = slides[currentIndex].dataset.imageId;
          thumbnails.forEach(function(thumb) {
            if (thumb.dataset.imageId === imageId) {
              thumb.classList.add('is-selected');
            }
          });
        }

        dots.forEach(function(dot) { dot.classList.remove('is-selected'); });
        if (dots[currentIndex]) dots[currentIndex].classList.add('is-selected');

        if (prevArrow) prevArrow.classList.toggle('is-disabled', currentIndex <= 0);
        if (nextArrow) nextArrow.classList.toggle('is-disabled', currentIndex >= slides.length - 1);
      }

      function getClosestSlideIndex() {
        var left = slideshow.scrollLeft;
        var closest = 0;
        var closestDist = Infinity;
        slides.forEach(function(slide, i) {
          var dist = Math.abs(slide.offsetLeft - left);
          if (dist < closestDist) { closestDist = dist; closest = i; }
        });
        return closest;
      }

      var scrollTimeout;
      var ticking = false;
      slideshow.addEventListener('scroll', function() {
        // Update dots in real-time via rAF so they track during the swipe
        if (!ticking) {
          ticking = true;
          requestAnimationFrame(function() {
            var closest = getClosestSlideIndex();
            if (closest !== currentIndex) {
              updateSelection(closest);
            }
            ticking = false;
          });
        }
        // Debounced final sync once scroll settles
        clearTimeout(scrollTimeout);
        scrollTimeout = setTimeout(function() {
          updateSelection(getClosestSlideIndex());
        }, 120);
      });

      thumbnails.forEach(function(thumb) {
        thumb.addEventListener('click', function(e) {
          e.preventDefault();
          var imageId = thumb.dataset.imageId;
          slides.forEach(function(slide, i) {
            if (slide.dataset.imageId === imageId) {
              scrollToSlide(i, 'smooth');
              updateSelection(i);
            }
          });
        });
      });

      dots.forEach(function(dot) {
        dot.addEventListener('click', function() {
          var idx = parseInt(dot.dataset.dotIndex, 10);
          if (slides[idx]) {
            scrollToSlide(idx, 'smooth');
            updateSelection(idx);
          }
        });
      });

      if (prevArrow) {
        prevArrow.addEventListener('click', function() {
          var idx = Math.max(0, currentIndex - 1);
          scrollToSlide(idx, 'smooth');
          updateSelection(idx);
        });
      }
      if (nextArrow) {
        nextArrow.addEventListener('click', function() {
          var idx = Math.min(slides.length - 1, currentIndex + 1);
          scrollToSlide(idx, 'smooth');
          updateSelection(idx);
        });
      }

      updateSelection(currentIndex);

      if (section) {
        section.addEventListener('variantImageSelected', function(e) {
          var imageId = e.detail ? e.detail.imageId : null;
          if (!imageId) return;
          slides.forEach(function(slide, i) {
            if (slide.dataset.imageId == imageId) {
              scrollToSlide(i, 'smooth');
              updateSelection(i);
            }
          });
        });
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shop-now"]) return;
  try {
    
  (function() {
    document.querySelectorAll('.shop-now-panel').forEach(function(panel) {
      var track = panel.querySelector('.shop-now-track');
      if (!track) return;

      var prev = panel.querySelector('.shop-now-arrow--prev');
      var next = panel.querySelector('.shop-now-arrow--next');
      var slideWidth = track.firstElementChild ? track.firstElementChild.offsetWidth : 300;

      function updateArrows() {
        if (prev) prev.classList.toggle('is-hidden', track.scrollLeft <= 10);
        if (next) next.classList.toggle('is-hidden', track.scrollLeft + track.clientWidth >= track.scrollWidth - 10);
      }

      if (prev) prev.addEventListener('click', function() {
        track.scrollBy({ left: -slideWidth, behavior: 'smooth' });
      });
      if (next) next.addEventListener('click', function() {
        track.scrollBy({ left: slideWidth, behavior: 'smooth' });
      });

      track.addEventListener('scroll', updateArrows);
      updateArrows();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonials"] && !Shopify.designMode) return;
  try {
    
  (function() {
    document.querySelectorAll('.testimonial-carousel').forEach(function(carousel) {
      var slides = carousel.querySelectorAll('.Carousel__Cell');
      if (slides.length < 2) return;

      var section = carousel.closest('[data-section-type="testimonials"]');
      var dots = section.querySelectorAll('.testimonial-dot');
      var navItems = section.querySelectorAll('.TestimonialNav__Item');
      var currentIndex = 0;
      var autoplayInterval = null;
      var autoplayDelay = carousel.dataset.autoplay;

      function goToSlide(index) {
        slides[currentIndex].classList.remove('is-selected');
        if (dots[currentIndex]) dots[currentIndex].classList.remove('is-selected');
        navItems.forEach(function(item) { item.classList.remove('is-selected'); });

        currentIndex = (index + slides.length) % slides.length;

        slides[currentIndex].classList.add('is-selected');
        if (dots[currentIndex]) dots[currentIndex].classList.add('is-selected');

        var slideIndex = parseInt(slides[currentIndex].dataset.slideIndex, 10);
        navItems.forEach(function(item) {
          if (parseInt(item.dataset.index, 10) === slideIndex) {
            item.classList.add('is-selected');
          }
        });
      }

      dots.forEach(function(dot, i) {
        dot.addEventListener('click', function() {
          goToSlide(i);
          restartAutoplay();
        });
      });

      navItems.forEach(function(item) {
        item.addEventListener('click', function() {
          var targetIndex = parseInt(item.dataset.index, 10);
          goToSlide(targetIndex);
          restartAutoplay();
        });
      });

      function startAutoplay() {
        if (autoplayDelay && autoplayDelay !== 'false') {
          autoplayInterval = setInterval(function() {
            goToSlide(currentIndex + 1);
          }, parseInt(autoplayDelay, 10));
        }
      }

      function restartAutoplay() {
        if (autoplayInterval) clearInterval(autoplayInterval);
        startAutoplay();
      }

      startAutoplay();
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
